import { Breadcrumb } from '@e3dc-react/shell/Elements/Header/Breadcrumbs'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { useHeaderBreadcrumbs } from '@e3dc-react/shell/Libs/Header'
import { appUpdate } from '@e3dc-react/shell/State/App/AppActions'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'

/**
 * Hook to set the breadcrumbs and page title for a given page.
 */
const useSetBreadcrumbsForPage = (parentBreadcrumb: Breadcrumb, titleKey: string): void => {
  const dispatch = useDispatch()
  const { t } = useCustomTranslation()
  const { setBreadcrumbs } = useHeaderBreadcrumbs()

  const title = t(titleKey)

  useEffect(() => {
    dispatch(appUpdate({ title }))
    setBreadcrumbs([parentBreadcrumb, { title }])

    return () => {
      setBreadcrumbs([])
    }
  }, [parentBreadcrumb, title, dispatch, setBreadcrumbs])
}

export default useSetBreadcrumbsForPage
